module.exports = __webpack_public_path__ + "img/seminarscoreimportoutput.ba4c91fe.png";